module.exports = fox._r("fonts/icons-lib/icons-lib.woff?n7cb91", __webpack_public_path__ + "_/_/_/root/fonts/icons-lib/3EtfDxI.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/icons-lib/icons-lib.woff?n7cb91
// module id = 378
// module chunks = 4